import React from 'react';

// Styles & Assets
import styles from './ButtonsZone.module.css';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa';

// Components
import Icon from '../../UI/Icon/Icon';

// Interfaces
import { Zone } from '../../../interfaces/Zone';
import { StateZoneAdministration } from '../../../interfaces/Administration';
interface Props {
    selectedItems: StateZoneAdministration
    currentZone: Zone | null,
    handleClickAdd: () => void
    handleClickRemove: () => void
}

const ButtonsZone: React.FC<Props> = ({ selectedItems, currentZone, handleClickAdd, handleClickRemove }) => {

    const disabledButtonLeft = currentZone === null ||
        (selectedItems.addBedIDs.length === 0 &&
        selectedItems.addTownIDs.length === 0);

    const disabledButtonRight = currentZone === null ||
        (selectedItems.removeBedIDs.length === 0 &&
        selectedItems.removeTownIDs.length === 0);

    return (
        <div className={styles.arrowButtons}>
            <button disabled={disabledButtonRight} onClick={handleClickRemove}>
                <Icon><FaChevronRight className={styles.iconButton} /></Icon>
            </button>
            <button disabled={disabledButtonLeft} onClick={handleClickAdd}>
                <Icon><FaChevronLeft className={styles.iconButton} /></Icon>
            </button>
        </div>
    );
};

export default ButtonsZone;